// *** URL Constants

// AZURE PUBLIC LINK FOR RESUME DOWNLOAD
export const resumeURL = "https://monikaresume.blob.core.windows.net/monika-resume/Resume.pdf";

// *** Icon Links

export const gmail = (
  <a
    href='https://mail.google.com/'
    target='_blank'
    rel='noopener noreferrer'
    aria-label='Gmail'
  >
    <i className='fas fa-envelope fa-2x'></i>
  </a>
);

export const linkedIn = (
  <a
    href='https://www.linkedin.com/in/monika12b/'
    target='_blank'
    rel='noopener noreferrer'
    aria-label='LinkedIn'
  >
    <i className='fab fa-linkedin fa-2x'></i>
  </a>
);

export const github = (
  <a
    href='https://www.github.com/Monika-ch/'
    target='_blank'
    rel='noopener noreferrer'
    aria-label='Github'
  >
    <i className='fab fa-github fa-2x'></i>
  </a>
);

export const resumeBtn = (
  <a
    href={resumeURL}
    download='Monika_Resume.pdf'
    target='_blank'
    rel='noopener noreferrer'
  >
    <button type='button' className='btn downloadResume'>
      Resume
    </button>
    <i className='fas fa-download'></i>
  </a>
);


// *** Icons, Logos and Texts for Tools, Technologies and Skills

export const javaScript = (
  <i className="fab fa-js"></i>
)

export const react = (
  <i className="fab fa-react"></i>
)

export const typeScript = (
  <p className="typescript">TS</p>
)

export const python = (
  <i className="fab fa-python"></i>
)

export const bootstrap = (
  <i className="fab fa-bootstrap"></i>
)

export const html = (
  <i className="fab fa-html5"></i>
)

export const css = (
  <i className="fab fa-css3"></i>
)

export const dom = (
  <p className="dom">DOM</p>
)

export const json = (
  <p className="json">JSON</p>
)

export const nodeJS = (
  <i className="fab fa-node"></i>
)

export const restAPI = (
  <p className="restAPI">RestAPI</p>
)

export const azure = (
  <p className="azure">Azure</p>
)

export const aws = (
  <i className="fab fa-aws"></i>
)

export const JQuery = (
  <p className="JQuery">JQuery</p>
)

export const cSharp = (
  <p className="cSharp">C#</p>
)

export const git = (
  <div>
    <i className="fab fa-github"></i>
    <p className="git d-inline-block">Git</p>
  </div>
)

export const vsCode = (
  <p className="vsCode">VS Code</p>
)

export const figma = (
  <div>
    <i className="fab fa-figma"></i>
    <p className="figma d-inline-block">Figma</p>
  </div>
)

export const lighthouse = (
  <p className="lighthouse">Lighthouse</p>
)

export const nvda = (
  <p className="nvda">NVDA</p>
)

export const accessibilityInsightsForWeb = (
  <p className="accessibility-insights">Accessibility Insights For Web</p>
)

export const reactDevTools = (
  <p className="react-dev-tools">React Dev Tools</p>
)

export const chromeDevTools = (
  <p className="chrome-dev-tools">Chrome Dev Tools</p>
)

export const awsAmplify = (
  <p className="aws-amplify">AWS Amplify</p>
)

export const azureDevOps = (
  <p className="azure-devops">Azure DevOps</p>
)

export const code = (
  <p className="code">Code</p>
)

export const test = (
  <p className="test">Test</p>
)

export const debug = (
  <p className="debug">Debug</p>
)

export const ABTesting = (
  <p className="AB-testing">A/B Testing</p>
)

export const accessibility = (
  <p className="accessibility">Accessibility</p>
)

export const prompting = (
  <p className="prompting">Prompting</p>
)

export const productDevelopment = (
  <p className="product-development">Product Development</p>
)

export const cicdAutomation = (
  <p className="cicd-automation">CI/CD Automation</p>
)

export const scrum = (
  <p className="scrum">Scrum</p>
)

export const AI = (
  <p className="AI">AI</p>
)

export const LLM = (
  <p className="LLM">LLM</p>
)
